































import ResourceItemTable from "@/components/resource/ResourceItemTable.vue";
import { createComponent } from "@vue/composition-api";
import {
  productGroupResource,
  brandResource,
  wyrobResource,
} from "@megarax/client/src/resources/plm";
import ResourceTableColumn from "@/components/ResourceTableColumn.vue";

export default createComponent({
  components: {
    ResourceItemTable,
    ResourceTableColumn,
  },
  setup(props, ctx) {
    return {
      resource: wyrobResource,
      brandResource,
      productGroupResource,
    };
  },
});
